import React from 'react';
import { observer } from 'mobx-react';
import { useMst } from '../../../internal';
import { Button } from '../../../components/UI/buttons/regular/Button';
import styles from './KreirajOdgovor.module.scss';

export const KvizDetalji = observer((): JSX.Element => {
  const { currentPage } = useMst();

  return (
    <div className={styles.PageContainer}>
      <h2 className={styles.Title}>Izmeni kviz</h2>

      <div className={styles.Form}>
        <div className={styles.Field}>
          <label htmlFor="name">Naziv *</label>
          <input
            id="name"
            type="text"
            value={currentPage.name}
            onChange={(e) => currentPage.setName(e.target.value)}
          />
        </div>

        <div className={styles.Field}>
          <label htmlFor="description">Opis</label>
          <input
            id="description"
            type="text"
            value={currentPage.description}
            onChange={(e) => currentPage.setDescription(e.target.value)}
          />
        </div>

        <div className={styles.Field}>
          <label htmlFor="quizType">Tip kviza *</label>
          <select
            id="quizType"
            value={currentPage.quizType}
            onChange={(e) => currentPage.setQuizType(e.target.value)}
          >
            <option value="" disabled>
              Izaberi tip
            </option>
            <option value="prepaid">Prepaid</option>
            <option value="coupon">Kupon</option>
          </select>
        </div>

        <div className={styles.Field}>
          <label htmlFor="startDate">Datum početka *</label>
          <input
            id="startDate"
            type="date"
            value={currentPage.startDate}
            onChange={(e) => currentPage.setStartDate(e.target.value)}
          />
        </div>

        <div className={styles.Field}>
          <label htmlFor="endDate">Datum završetka *</label>
          <input
            id="endDate"
            type="date"
            value={currentPage.endDate}
            onChange={(e) => currentPage.setEndDate(e.target.value)}
          />
        </div>

        <div className={styles.Field}>
          <label htmlFor="startTime">Vreme početka *</label>
          <input
            id="startTime"
            type="time"
            value={currentPage.startTime}
            onChange={(e) => currentPage.setStartTime(e.target.value)}
          />
        </div>

        <div className={styles.Field}>
          <label htmlFor="endTime">Vreme završetka *</label>
          <input
            id="endTime"
            type="time"
            value={currentPage.endTime}
            onChange={(e) => currentPage.setEndTime(e.target.value)}
          />
        </div>

        <div className={styles.Field}>
          <label htmlFor="resultsVisibleUntil">Rezultati vidljivi do</label>
          <input
            id="resultsVisibleUntil"
            type="datetime-local"
            value={currentPage.resultsVisibleUntil}
            onChange={(e) => currentPage.setResultsVisibleUntil(e.target.value)}
          />
        </div>

        <div className={styles.Field}>
          <label htmlFor="dailyWinnersCount">Broj dnevnih pobednika</label>
          <input
            id="dailyWinnersCount"
            type="number"
            min={1}
            value={currentPage.dailyWinnersCount}
            onChange={(e) =>
              currentPage.setDailyWinnersCount(Number(e.target.value))
            }
          />
        </div>

        <div className={styles.CheckboxField}>
          <input
            id="isActive"
            type="checkbox"
            checked={currentPage.isActive}
            onChange={(e) => currentPage.setIsActive(e.target.checked)}
          />
          <label htmlFor="isActive">Aktivan</label>
        </div>

        <div className={styles.Actions}>
          <Button
            onClick={() => currentPage.submit()}
            disabled={!currentPage.isValid}
          >
            Sačuvaj
          </Button>
          <Button onClick={() => currentPage.navigateBack()}>Otkaži</Button>
          <Button onClick={() => currentPage.navigateToPitanja()}>
            Pitanja
          </Button>
        </div>
      </div>
    </div>
  );
});
